export const LOGIN_ACTIONS = {
  USER_TYPES_EMAIL: 'USER_TYPES_EMAIL',
  USER_TYPES_PASSWORD: 'USER_TYPES_PASSWORD',
  RESET_STATE: 'RESET_STATE',
  FORM_LOADING: 'FORM_LOADING',
};

export const INITIAL_LOGIN_STATE = {
  email: {
    value: '',
    errors: [],
  },
  password: {
    value: '',
    errors: [],
  },
  loading: false,
  formErrors: [],
};

export const loginReducer = (state, action) => {
  switch (action.type) {
    case LOGIN_ACTIONS.USER_TYPES_EMAIL:
      return {
        ...state,
        email: {
          value: action.payload || '',
          errors: [],
        },
      };
    case LOGIN_ACTIONS.USER_TYPES_PASSWORD:
      return {
        ...state,
        password: {
          value: action.payload || '',
          errors: [],
        },
      };
    case LOGIN_ACTIONS.RESET_STATE:
      return { ...state, ...action.payload };
    case LOGIN_ACTIONS.FORM_LOADING:
      return { ...state, loading: action.payload };
    default:
      return state;
  }
};

export default loginReducer;
